import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import {TypeDescMarche} from './TypeDescMarche';
import {Procedure} from './Procedure';
export class Annulation {

	public infosAnnulation: string;

	public avisInitial: AvisInitialTypeLight;

	public description: TypeDescMarche;

	public procedure: Procedure;

	constructor() {
		 		this.infosAnnulation = '';
		this.avisInitial = new AvisInitialTypeLight();
		this.description = new TypeDescMarche();
		this.procedure = new Procedure();

	}
}
